import { takeLatest, put } from 'redux-saga/effects';
import { setSearchState, appNotify, fetchSearch, fetchSearchLastPricedByMe } from 'store/actions';
import { postWithToken, getWithToken } from 'api/network';

export function* searchResultFetchSaga() {
  yield takeLatest(setSearchState, function* ({ payload: searchState }) {
    if (searchState?.searchValue === "") {
      // clear search results
      yield put(setSearchState({ data: [], resultsLimited: false, importCount: 0, propertyCount: 0, auctionCount: 0 }));
    }
    if (searchState?.searchValue && searchState.searchValue.length > 0) {
      yield put(fetchSearch(searchState.searchValue));
    }
  });

  yield takeLatest(fetchSearch, function* ({ payload: searchValue }) {
    try {
      yield put(setSearchState({ loading: true, isSearchingLastPriced: false }));
      let res;
      res = yield postWithToken(`/api/underwrite/search`, searchValue);
      const data = yield res.json();
      yield put(setSearchState({ loading: false }));
      let [searchData, importCount, propertyCount, opportunitiesCount, auctionCount, hasMoreData] = processData(data);
      yield put(setSearchState({ data: searchData, resultsLimited: hasMoreData, importCount, opportunitiesCount, propertyCount, auctionCount }));
    } catch (error) {
      yield put(setSearchState({ loading: false }));
      yield put(appNotify(error.message, 'error'));
    }
  });

  yield takeLatest(fetchSearchLastPricedByMe, function* () {
    try {
      yield put(setSearchState({
        loading: true,
        isSearchingLastPriced: true,
        searchBoxValue: '',
        searchValue: ''
      }));
      let res;
      res = yield getWithToken(`/api/underwrite/search/getTxnOppsLastPricedByMe`);
      const data = yield res.json();
      yield put(setSearchState({ loading: false }));

      let [searchData, importCount, propertyCount, opportunitiesCount, auctionCount, hasMoreData] = processData(data);
      yield put(setSearchState({ data: searchData, resultsLimited: hasMoreData, importCount, opportunitiesCount, propertyCount, auctionCount }));
    } catch (error) {
      yield put(setSearchState({ loading: false }));
      yield put(appNotify(error.message, 'error'));
    }
  })
}

function processData(data) {
  let newData = [];
  let propertyCount = 0;
  let auctionCount = 0;
  let importCount = 0;
  let hasResultsHidden = false;
  for (let i = 0; i < data.length; i++) {
    let searchResult = {};
    switch (data[i].resultType) {
      case "import":
        searchResult.resultType = data[i].resultType;
        searchResult.id = data[i].id;
        searchResult.channel = data[i].channel;
        searchResult.title = data[i].importName;
        searchResult.importedBy = data[i].importedBy;
        searchResult.importedOn = new Date(data[i].createdOn);
        searchResult.portfolioName = null;
        searchResult.data = [`Imported: ${data[i].importCount}, Opportunities: ${data[i].opportunitiesCount}`];
        if (importCount < 20) {
          importCount++;
          newData.push(searchResult);
        } else {
          hasResultsHidden = true;
        }
        break;
      case "property":
        searchResult.resultType = data[i].resultType;
        searchResult.id = data[i].id;
        searchResult.userId = data[i].userId;
        searchResult.channel = data[i].channel;
        searchResult.title = data[i].fullAddress;
        searchResult.importedBy = data[i].importedBy;
        searchResult.importedOn = new Date(data[i].createdOn);
        searchResult.portfolioName = data[i].portfolioName;
        searchResult.opportunityStatus = data[i].opportunityStatus;
        searchResult.underwriteStatus = data[i].underwriteStatus;
        searchResult.latestPricingDateTime = data[i].latestPricingDateTime ? new Date(data[i].latestPricingDateTime) : null;
        searchResult.data = [[showData(data[i].beds, " beds"), showData(data[i].baths, " baths"), showData(data[i].yearBuilt, " built"), showData(data[i].sqft, "sf")].join(" ")];
        if (propertyCount < 100) {
          propertyCount++;
          newData.push(searchResult);
        } else {
          hasResultsHidden = true;
        }
        break;
      case "auction":
        searchResult.resultType = data[i].resultType;
        searchResult.id = data[i].id;
        searchResult.title = data[i].portfolioName;
        searchResult.importedBy = "";
        searchResult.importedOn = new Date(data[i].createdOn);
        searchResult.completedOn = data[i].completedOn ? new Date(data[i].completedOn) : null;
        searchResult.portfolioName = null;
        searchResult.data = [showData(data[i].portfolioCount, " properties")];
        if (auctionCount < 20) {
          auctionCount++;
          newData.push(searchResult);
        } else {
          hasResultsHidden = true;
        }
        break;
      default:
        break;
    }
  }
  return [newData, importCount, propertyCount, auctionCount, hasResultsHidden];
}

function showData(property, display) {
  if (property) {
    return property + display;
  }
  return "";
}
